import * as React from 'react';

import DefaultLayout from './DefaultLayout';

import type { PageProps } from 'gatsby';

type LayoutProps = Omit<PageProps<any, Queries.SitePage['pageContext']>, 'children'> & {
  children: React.ReactNode;
};

const Layout = ({ children, ...props }: LayoutProps) => {
  if (
    ['/en/', '/ja/', '/ko/', '/zh-Hant/', '/th/', '/fr/', '/de/'].some((path) =>
      props.location.pathname.startsWith(path),
    )
  ) {
    return <DefaultLayout {...props}>{children}</DefaultLayout>;
  }
  return children;
};

export default Layout;
